import * as emailValidator from 'email-validator';

export function opportunityIdLinkConverter(userInput: string): string {
  // Salesforce Opportunity ID validation
  const pattern = /https:\/\/snowforce\.lightning\.force\.com\/lightning\/r\/Opportunity\/([a-zA-Z0-9]+)\/view/;
  const match = pattern.exec(userInput);
  if (match !== null) {
    return match[1]; // return the opportunity ID
  }
  return userInput;
}

// enum for validation levels from 0 to 3
export enum ValidationLevel {
  None = 0,
  AllowEmpty = 1,
  AllChecks = 2,
}

export function salesForceIdValidation(_id: string, level: ValidationLevel): string {
  if (level === ValidationLevel.AllChecks && _id.length === 0) {
    return 'ID required.';
  }

  const pattern = /[ %&?#]/;
  if (_id.length === 0) {
    return '';
  } else if (_id.length > 18) {
    return 'ID too long (expecting 18 characters), please check the ID in Salesforce.';
  } else if (_id.length < 18) {
    return 'ID too short (expecting 18 characters), please check the ID in Salesforce.';
  } else if (pattern.exec(_id) !== null) {
    return 'Spaces and special chars are unexpected.';
  }
  return '';
}

/**
 * Validates an email address using the email-validator package.
 *
 * @param email - The email address to validate
 * @returns true if the email is valid, false otherwise
 */
export function validateEmail(email: string): boolean {
  return emailValidator.validate(email);
}

/**
 * Validates an event name to ensure it does not contain characters that could
 * cause SQL injection or breakage when embedded in Snowflake SQL strings.
 *
 * Blocked characters/sequences: apostrophe, semicolon, backslash, --, slash-star, star-slash
 *
 * @param name - The event name to validate
 * @returns An error message string if invalid, or null if valid
 */
export function validateEventName(name: string): string | null {
  if (name.includes("'")) {
    return "Event name cannot contain apostrophes (')";
  }
  if (name.includes(';')) {
    return 'Event name cannot contain semicolons (;)';
  }
  if (name.includes('\\')) {
    return 'Event name cannot contain backslashes (\\)';
  }
  if (name.includes('--')) {
    return 'Event name cannot contain double dashes (--)';
  }
  if (name.includes('/*') || name.includes('*/')) {
    return 'Event name cannot contain SQL block comment sequences (/* or */)';
  }
  return null;
}

/**
 * Validates an event slug to ensure it:
 * - Starts with a letter (A-Z, a-z)
 *
 * @param slug - The event slug to validate
 * @returns An error message string if invalid, or null if valid
 */
export function validateEventSlug(slug: string): string | null {
  if (!slug) return null;
  if (!/^[a-zA-Z]/.test(slug)) {
    return 'Event unique ID must start with a letter';
  }
  return null;
}
